import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import {
    GET_ALL_APP_SUBSCRIPTIONS_QUERY,
    GetAllAppSubscriptionsResponse,
    GetAllAppSubscriptionsVariables,
} from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import { shopifyGraphQL } from 'hooks/shopify/shopify-graphql';
import BillingShopifyAppPricingService from 'services/BillingShopifyAppPricingService';
import { mapEveryBigintIntoNumber } from 'utils/map-every-bigint-into-number';
import { ShopifyPlansResponse } from '../../../../pb/responses/v1/shopify_plans_response_pb';

export const getShopifyAppPlans = createAsyncThunk<ShopifyPlansResponse>(
    '[shopifyAppPricing] getShopifyAppPlans',
    async () => {
        return BillingShopifyAppPricingService.getPlans().then(
            (response) => mapEveryBigintIntoNumber(response) as ShopifyPlansResponse
        );
    }
);

export const getShopifyAppSubscription = createAsyncThunk<GetAllAppSubscriptionsResponse>(
    '[shopifyAppPricing] getShopifyAppSubscription',
    async (_, { rejectWithValue }) => {
        try {
            return await shopifyGraphQL<GetAllAppSubscriptionsResponse, GetAllAppSubscriptionsVariables>(
                GET_ALL_APP_SUBSCRIPTIONS_QUERY,
                { first: 20 }
            );
        } catch (error) {
            console.error(error);
            Sentry.captureException(error);
            return rejectWithValue(error);
        }
    }
);
